export default "__VITE_ASSET__923da366__"